import { getMcpApiUrl } from 'components/pages/SchemasV2/WorkspaceSettings/mcpUrl';

export type BrowserLoginRequest = {
  redirectUri: string;
  state: string;
};

export const getBrowserLoginRequest = (
  params: URLSearchParams
): BrowserLoginRequest | undefined => {
  const redirectUri = params.get('redirect_uri');
  const state = params.get('state');
  if (
    !redirectUri ||
    !state ||
    params.get('intent') !== 'api_client' ||
    params.has('issuer_state') ||
    params.has('pod')
  ) {
    return undefined;
  }
  try {
    const target = new URL(redirectUri);
    if (
      target.protocol !== 'http:' ||
      target.hostname !== '127.0.0.1' ||
      !target.port ||
      target.pathname !== '/callback' ||
      target.username ||
      target.password ||
      target.search ||
      target.hash
    )
      return undefined;
    return { redirectUri: target.toString(), state };
  } catch {
    return undefined;
  }
};

export const getBrowserLoginDestination = ({
  request,
  workspace,
}: {
  request: BrowserLoginRequest;
  workspace: { id: string; pod: { customerApiUrl: string } };
}) => {
  const target = new URL(request.redirectUri);
  const mcpUrl = new URL(getMcpApiUrl(workspace.pod.customerApiUrl));
  target.search = new URLSearchParams({
    state: request.state,
    workspace_id: workspace.id,
    mcp_url: mcpUrl.origin,
  }).toString();
  return target.toString();
};
